export default __webpack_public_path__ + "static/media/fork.39dc0b31.svg";